import React, { Component } from "react";
import PropTypes from "prop-types";

class TimeTextField extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    onChange: () => {},
    defaultValue: "0:0",
    disabled: false,
  };

  constructor(props) {
    super(props);
    let valueArray = props.defaultValue && props.defaultValue.split(":");
    if (valueArray.length !== 2) {
      valueArray = ["0", "0"];
    }
    this.state = {
      hours: valueArray[0],
      minutes: valueArray[1],
      oldHours: valueArray[0],
      oldMinutes: valueArray[1],
    };
  }

  onChangeMinutes = (newMinutes) => {
    this.setState(
      { minutes: newMinutes, oldMinutes: newMinutes },
      this.onChange
    );
  };

  onChangeHours = (newHours) => {
    this.setState({ hours: newHours, oldHours: newHours }, this.onChange);
  };

  onChange = () => {
    const { hours, minutes } = this.state;
    const { onChange } = this.props;
    onChange(hours + ":" + minutes);
  };

  render() {
    const { disabled } = this.props;
    const { hours, minutes } = this.state;
    return (
      <div
        style={{
          border: "1px solid #d9d9d9",
          width: "125px",
          height: "30px",
          padding: "5px 10px",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          direction: "ltr",
        }}
      >
        <input
          type={"number"}
          min={-999}
          max={999}
          style={{
            width: "55px",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            padding: "0 3px",
            textAlign: "center",
            direction: "ltr",
          }}
          value={hours}
          disabled={disabled}
          onChange={(e) => {
            let newNumber = parseInt(e.target.value);
            if (
              newNumber < 1000 &&
              newNumber > -1000 &&
              e.target.value.length < 5
            ) {
              this.onChangeHours(e.target.value);
            } else if (isNaN(newNumber)) {
              this.onChangeHours(e.target.value);
            } else {
              this.onChangeHours(this.state.oldHours);
            }
          }}
          onKeyDown={(e) => {
            if (e.target.value.length < 5)
              this.setState({ oldHours: e.target.value });
          }}
        />
        <p style={{ padding: "0 3px" }}>{":"}</p>
        <input
          type={"number"}
          min={0}
          max={59}
          style={{
            width: "40px",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            padding: "0 3px",
            textAlign: "center",
            direction: "ltr",
          }}
          value={minutes}
          disabled={disabled}
          onChange={(e) => {
            let newNumber = parseInt(e.target.value);
            if (newNumber < 60 && newNumber > -1 && e.target.value.length < 3) {
              this.onChangeMinutes(e.target.value);
            } else if (isNaN(newNumber)) {
              this.onChangeMinutes(e.target.value);
            } else {
              this.onChangeMinutes(this.state.oldMinutes);
            }
          }}
          onKeyDown={(e) => {
            if (e.target.value.length < 3)
              this.setState({ oldMinutes: e.target.value });
          }}
        />
      </div>
    );
  }
}

export default TimeTextField;
